import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  HeadlineAssetCollection,
  LongHeadlineAssetCollection,
  DescriptionAssetCollection,
} from '@bingads-webui-campaign-react/pmax-text-input';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getImageExperienceStyles } from '../../styles';

const TextAssetCollectionWithCoPilotInternal = (props) => {
  const {
    fetchRecommendationAssets,
    cancelFetchRecommendationAssetsJob,
    setAddNewShortHeadlinesCallback,
    setAddNewLongHeadlinesCallback,
    setAddNewDescriptionCallback,
    isAudienceAd,
  } = props;

  const classes = useDefaultStyles(getImageExperienceStyles);
  const permissions = useContext(PermissionsContext);

  const headlineAssetCollection = useMemo(() => (
    <HeadlineAssetCollection
      fetchRecommendationAssets={fetchRecommendationAssets}
      cancelFetchRecommendationAssetsJob={cancelFetchRecommendationAssetsJob}
      isOptional={false}
      showDeleteButton
      featureName="displayPlus"
      enableCopilotRecommendations={permissions.dynamic.DisplayPlusCopilotRecommendations}
      setAddNewShortHeadlinesCallback={setAddNewShortHeadlinesCallback}
      isAudienceAd={isAudienceAd}
    />
  ), [fetchRecommendationAssets, cancelFetchRecommendationAssetsJob, permissions.dynamic.DisplayPlusCopilotRecommendations, setAddNewShortHeadlinesCallback, isAudienceAd]);

  const longHeadlineAssetCollection = useMemo(() => (
    <LongHeadlineAssetCollection
      fetchRecommendationAssets={fetchRecommendationAssets}
      cancelFetchRecommendationAssetsJob={cancelFetchRecommendationAssetsJob}
      isOptional={false}
      showDeleteButton
      featureName="displayPlus"
      enableCopilotRecommendations={permissions.dynamic.DisplayPlusCopilotRecommendations}
      setAddNewLongHeadlinesCallback={setAddNewLongHeadlinesCallback}
    />
  ), [fetchRecommendationAssets, cancelFetchRecommendationAssetsJob, permissions.dynamic.DisplayPlusCopilotRecommendations, setAddNewLongHeadlinesCallback]);

  const descriptionAssetCollection = useMemo(() => (
    <DescriptionAssetCollection
      fetchRecommendationAssets={fetchRecommendationAssets}
      cancelFetchRecommendationAssetsJob={cancelFetchRecommendationAssetsJob}
      isOptional={false}
      showDeleteButton
      featureName="displayPlus"
      enableCopilotRecommendations={permissions.dynamic.DisplayPlusCopilotRecommendations}
      setAddNewDescriptionCallback={setAddNewDescriptionCallback}
    />
  ), [fetchRecommendationAssets, cancelFetchRecommendationAssetsJob, permissions.dynamic.DisplayPlusCopilotRecommendations, setAddNewDescriptionCallback]);

  return (
    <div className={classNames('text-asset-collections', classes.textAssetStyle)}>
      {headlineAssetCollection}
      {longHeadlineAssetCollection}
      {descriptionAssetCollection}
    </div>
  );
};

TextAssetCollectionWithCoPilotInternal.propTypes = {
  fetchRecommendationAssets: PropTypes.func.isRequired,
  cancelFetchRecommendationAssetsJob: PropTypes.func.isRequired,
  setAddNewShortHeadlinesCallback: PropTypes.func.isRequired,
  setAddNewLongHeadlinesCallback: PropTypes.func.isRequired,
  setAddNewDescriptionCallback: PropTypes.func.isRequired,
  isAudienceAd: PropTypes.bool,
};

TextAssetCollectionWithCoPilotInternal.defaultProps = {
  isAudienceAd: false,
};

export const TextAssetCollectionWithCoPilot = withCustomValidation(TextAssetCollectionWithCoPilotInternal);
